var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringDeposits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28C27.8807 28 29 26.8807 29 25.5C29 24.1193 27.8807 23 26.5 23C25.1193 23 24 24.1193 24 25.5C24 26.8807 25.1193 28 26.5 28Z",
    stroke: "#183883",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 23V28",
    stroke: "#183883",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 32C22 32.75 21.79 33.46 21.42 34.06C20.73 35.22 19.46 36 18 36C16.54 36 15.27 35.22 14.58 34.06C14.21 33.46 14 32.75 14 32C14 29.79 15.79 28 18 28C20.21 28 22 29.79 22 32Z",
    stroke: "#183883",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32H16",
    stroke: "#183883",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 30V34",
    stroke: "#183883",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29.0063V22.3125C15 18.5938 17.2 17 20.5 17H31.5C34.8 17 37 18.5938 37 22.3125V28.6875C37 32.4062 34.8 34 31.5 34H21.5",
    stroke: "#183883",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringDeposits);
export default __webpack_public_path__ + "static/media/RecurringDeposits.d02c4ef3aacc99b7e3818f48f564a23b.svg";
export { ForwardRef as ReactComponent };